export const unlockPageScrollOnMobileOnly = () => {
  document.documentElement.classList.remove('modal-open');
};

export const unlockPageScrollAllViewports = () => {
  document.documentElement.classList.remove('modal-open-all-viewports');
};
